import { gql } from '@apollo/client';

/**
 * GraphQL query to fetch policy content for a standard label
 */
export const GET_LABEL_POLICY_CONTENT = gql`
  query GetLabelPolicyContent($labelId: ID!, $filename: String) {
    labelPolicyContent(labelId: $labelId, filename: $filename) {
      labelId
      policyFile
      content
      lastModified
    }
  }
`;
